module.exports = __webpack_public_path__ + "media/assets/img/flags/kk-KZ-55321e0f4e0f15a6cd99e52613ba5cfc.png";